import dayjs from 'dayjs';
import { storeDay } from './storeTime';

/**
 * How far off a booking's day is, on the salon's calendar: "today",
 * "tomorrow", "in 3 days". Never "in 1 days" or "in 0 days", and never a day
 * the visitor's own device would count (a phone abroad can be on another
 * date). Empty for a day already gone.
 */
export const inDays = (day: string, now: string | number | Date = Date.now()): string => {
  const n = dayjs(day, 'YYYY-MM-DD').diff(dayjs(storeDay(now), 'YYYY-MM-DD'), 'day');
  if (n < 0 || Number.isNaN(n)) return '';
  if (n === 0) return 'today';
  if (n === 1) return 'tomorrow';
  return `in ${n} days`;
};

/** The same, starting a line: "In 3 days". */
export const inDaysTitle = (day: string, now?: string | number | Date) => {
  const words = inDays(day, now);
  return words ? words[0].toUpperCase() + words.slice(1) : '';
};
